import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import { colors } from '../../../../../../colorVars';
import { activateTradePlan } from '../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/activateTradePlan';
import {
  enterLong,
  enterShort,
} from '../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/enterNow';
import { pauseTradePlan } from '../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/pauseTradePlan';
import { removeTradePlan } from '../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/removeTradePlan';
import { restartPersistingTradePlan } from '../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/restartPersistingTradePlan';
import { useWebsocketStore } from '../../../../../../stores/websocketStore/websocketProvider';
import TextButton from '../../../../../atomic/buttons/textButton/TextButton';

const NotInPositionButtonArray = observer(({ tradePlanId }) => {
  const { tradePlanStore } = useWebsocketStore();
  const tradePlan = tradePlanStore.tradePlans[tradePlanId];
  const isPending = tradePlan?.__pending === true;

  let direction;
  if (tradePlan.goLong && tradePlan.goShort) direction = 'Both';
  else if (tradePlan.goLong) direction = 'Long';
  else direction = 'Short';
  if (isPending) {
    return (
      <TextButton
        margin="0 5px 0 0"
        disabled
        fontSize="medium"
        color={colors.white}
        backgroundColor={colors.grey}
        width="205px"
      >
        Creating Trade Plan...
      </TextButton>
    );
  }
  return (
    <>
      {!tradePlan.inPosition &&
      tradePlan.restartSystemOncePositionHasFlattened &&
      tradePlan.restartSettings.deactivated ? (
        <>
          <TextButton
            margin="0 5px 0 0"
            fontSize="medium"
            color={colors.white}
            backgroundColor={colors.green}
            width="100px"
            clickHandler={() => activateTradePlan(tradePlan.id, true)}
          >
            ACTIVATE
          </TextButton>
          <TextButton
            margin="0 5px 0 0"
            disabled={!tradePlan.inPersistingState}
            fontSize="medium"
            color={colors.white}
            backgroundColor={
              tradePlan.inPersistingState ? colors.blue : colors.grey
            }
            width="100px"
            clickHandler={() => restartPersistingTradePlan(tradePlan.id, true)}
          >
            RESTART
          </TextButton>
        </>
      ) : (
        <>
          <TextButton
            margin="0 5px 0 0"
            fontSize="medium"
            color={colors.white}
            backgroundColor={colors.orange}
            width="100px"
            dataCommand={tradePlan.paused ? 'resume' : 'pause'}
            clickHandler={() => {
              pauseTradePlan(tradePlan.id, !tradePlan.paused);
            }}
          >
            {tradePlan.paused ? 'UNPAUSE' : 'PAUSE'}
          </TextButton>

          <TextButton
            margin="0 5px 0 0"
            disabled={!tradePlan.inPersistingState}
            fontSize="medium"
            color={colors.white}
            backgroundColor={
              tradePlan.inPersistingState ? colors.blue : colors.grey
            }
            width="100px"
            clickHandler={() => restartPersistingTradePlan(tradePlan.id, true)}
          >
            RESTART
          </TextButton>
        </>
      )}
      <TextButton
        margin="0 5px 0 0"
        fontSize="medium"
        color={colors.white}
        backgroundColor={colors.red}
        width="100px"
        dataCommand="cancel"
        clickHandler={() => removeTradePlan(tradePlan.id)}
      >
        CANCEL
      </TextButton>

      <TextButton
        margin="0 5px 0 0"
        disabled={direction === 'Short'}
        fontSize="medium"
        color={colors.white}
        backgroundColor={direction === 'Short' ? colors.grey : colors.green}
        width="100px"
        dataCommand="enter-long"
        clickHandler={() => enterLong(tradePlan.id)}
      >
        ENTER LONG
      </TextButton>
      <TextButton
        margin="0 5px 0 0"
        padding="5px 4px 5px 4px"
        disabled={direction === 'Long'}
        fontSize="medium"
        color={colors.white}
        backgroundColor={direction === 'Long' ? colors.grey : colors.green}
        width="100px"
        dataCommand="enter-short"
        clickHandler={() => enterShort(tradePlan.id)}
      >
        ENTER SHORT
      </TextButton>
    </>
  );
});

NotInPositionButtonArray.propTypes = {
  tradePlan: PropTypes.shape({
    goLong: PropTypes.bool,
    goShort: PropTypes.bool,
    id: PropTypes.any,
    inPosition: PropTypes.bool,
    paused: PropTypes.bool,
    restartSettings: PropTypes.shape({
      deactivated: PropTypes.bool,
    }),
    restartSystemOncePositionHasFlattened: PropTypes.bool,
  }),
};

export default NotInPositionButtonArray;
